import { useRouter } from "next/router";
import { useEffect, useState } from "react";

const useEmbeds = () => {
  const { asPath } = useRouter();
  const [isInsideIframe, setIsInsideIframe] = useState(false);
  const [isInsideIframeAndOnCurrentUrl, setIsInsideIframeAndOnCurrentUrl] =
    useState(false);

  useEffect(() => {
    if (window.self !== window.top) {
      setIsInsideIframe(true);

      if (
        document.referrer?.split("/")[2]?.replace(/\/$/, "") ===
        window.location.hostname?.replace(/\/$/, "")
      )
        setIsInsideIframeAndOnCurrentUrl(true);
    }
  }, []);

  return {
    isEmbed: asPath.includes("/embeds/"),
    isInsideIframeAndOnCurrentUrl,
    isInsideIframe
  };
};

export default useEmbeds;
